import { supabase } from "../supabase";

export const uploadPublicFile = async (file, bucket, fileName) => {
  const ext = file.name.split('.').pop();
  const path = `${fileName}.${ext}`;
  const { error } = await supabase.storage
    .from(bucket)
    .upload(path, file, { upsert: true });
  if (error) throw new Error("Upload falló: " + error.message);
  const { data: urlData } = supabase.storage.from(bucket).getPublicUrl(path);
  return urlData.publicUrl;
};
